// extracted by mini-css-extract-plugin
export default {"playerAxis":"player-axis_playerAxis__z4OKX"};